<template>
  <div>
    <div class="redisMonitor-title">
      <div>DocDB</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['monitor:DocDBMonitor:add_alert_rule']"
          @click="addOrUpdateHandle"
          >{{ $t("DocDBMonitor.addRedshift") }}</Button
        >
        <add-or-update-redis-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-redis-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" v-model="currentTab" :animated="false">
        <TabPane :label="$t('DocDBMonitor.redshiftList')" name="tabDisk">
          <div class="redisMonitor-top">
            <redis-monitor-search></redis-monitor-search>
          </div>
          <table-redis></table-redis>
        </TabPane>
        <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
          <div class="redisMonitor-top">
            <redis-monitor-alert-rule-search></redis-monitor-alert-rule-search>
          </div>
          <table-redis-warning></table-redis-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import RedisMonitorSearch from "./RedisMonitorSearch";
import TableRedis from "./TableRedis";
import AddOrUpdateRedisWarning from "./AddOrUpdateRedisWarning";
import RedisMonitorAlertRuleSearch from "./RedisMonitorAlertRuleSearch";
import TableRedisWarning from "./TableRedisWarning";
const tableRedisWarning = TableRedisWarning;
export default {
  name: "RedisMonitor",
  components: {
    RedisMonitorSearch,
    TableRedis,
    AddOrUpdateRedisWarning,
    RedisMonitorAlertRuleSearch,
    TableRedisWarning
  },
  data() {
    return {
      addOrUpdateVisible: false,
      currentTab: ""
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    changeCurrentTab: function(row, monitorIndex) {
      this.currentTab = "tabAlertRule";
      eventBus.$emit("volumeId", row.volumeAwsId);
      eventBus.$emit("monitorIndex", monitorIndex);
      eventBus.$emit("typeId", 1);
      // eventBus.$emit('stateId', 0);
      tableRedisWarning.methods.showAll();
    }
  }
};
</script>

<style scoped>
.redisMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.redisMonitor-title > div:nth-child(1) {
  float: left;
}
.redisMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.redisMonitor-top {
  width: 100%;
  height: 32px;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/RedisMonitor.vue